// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"674":"6aa5e9c1","895":"adcfebb6"}[chunkId] + ".chunk.css";
};